import {useQuery} from '@tanstack/react-query'

import {getRestaurantDetailInfo} from '@/lib/food-grubhub/foodGrubhubService'
import type {RestaurantDetailQueryProps} from '@/lib/food-grubhub/foodRestaurantDetailModel'

const useRestaurantInformationDetail = (params: RestaurantDetailQueryProps, token: string) => {
  return useQuery({
    queryKey: ['restaurant_detail', params, token],
    queryFn: async () =>
      getRestaurantDetailInfo({
        restaurantId: params.restaurantId ?? '',
        hideChoiceCategories: params.hideChoiceCategories ?? false,
        version: params.version ?? 4,
        variationId: params.variationId ?? '',
        orderType: params.orderType ?? null,
        hideUnavailableMenuItems: params.hideUnavailableMenuItems ?? false,
        hideMenuItems: params.hideMenuItems ?? false,
        locationMode: params.locationMode ?? '',
        location: params.location ?? '',
        token,
        signal: undefined,
      }),
    enabled: !!token,
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    staleTime: 1000 * 60 * 5,
  })
}

export default useRestaurantInformationDetail
